import {createDivIn, createHeaderIn, createParagraphIn, setElementOnClick} from '../ui_utils/DomUtils'
import {Sound} from '../Sound'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {TimeUtils} from '../../../../shared/utils/TimeUtils'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'

// date: Sept 19, 2020
// author: Jeff
// problem: players spamming refresh to make a popup that would block plaeyrs from making moves
// notes: This was a quick fix to stop players from doing that
// ideal solution: this should be an element in the game canvas and not the html, this should be refactored out in the future

export class ViewPopupTemporary {
    private readonly container: HTMLDivElement
    private readonly contentContainer: HTMLDivElement
    private readonly header: HTMLDivElement
    private readonly body: HTMLDivElement
    private readonly footer: HTMLDivElement
    readonly checkButton: HTMLDivElement

    constructor(title: TranslationObject, body: TranslationObject) {
        this.removeOldPopupIfExists()
        this.container = createDivIn(document.body, 'popup-notification')
        this.contentContainer = createDivIn(this.container, 'popup-content-temporary')
        this.header = createDivIn(this.contentContainer, 'popup-header')
        this.body = createDivIn(this.contentContainer, 'popup-body')
        this.footer = createDivIn(this.contentContainer, 'popup-footer')

        this.setCancel()

        this.checkButton = createDivIn(this.footer, 'btn_general btn_general_check')
        setElementOnClick(this.checkButton, () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
        })

        this.positionContainerInTopRightCorner()

        createHeaderIn(this.header, title, '', '', 'H4')
        createParagraphIn(this.body, body, '')

        this.show()

        const timeout = 6 * TimeUtils.MILLISECONDS
        setTimeout(() => {
            this.removePopup()
        }, timeout)
    }

    // eslint-disable-next-line class-methods-use-this
    private removeOldPopupIfExists() {
        const oldPopup = document.querySelector('.popup-notification')
        if(oldPopup != null) oldPopup.remove()
    }

    private setCancel() {
        window.addEventListener('click', (event) => {
            if(event.target == this.container) {
                this.removePopup()
            }
        })
    }

    private positionContainerInTopRightCorner() {
        const canvas = uiGameManager.canvasController
        const scaleForRotation = uiGameManager.canvasController.responsiveController.getScaleForRotation()
        const canvasXPosition = canvas.responsiveController.getCanvasX()
        const xPosition = scaleForRotation * (canvas.appW - canvas.chatWidth * 2) + canvasXPosition
        const yPosition = canvas.responsiveController.getCanvasY()

        this.contentContainer.style.position = 'absolute'
        this.contentContainer.style.transform = 'none'

        this.contentContainer.style.width = UIUtilsEjsVariables.isUserOnMobileApp ? '70vw' : canvas.chatWidth * scaleForRotation + 'px'
        this.contentContainer.style.left = UIUtilsEjsVariables.isUserOnMobileApp ? '15vw' : xPosition + 'px'
        this.contentContainer.style.top = UIUtilsEjsVariables.isUserOnMobileApp ? '40vh' : yPosition + 'px'
        this.contentContainer.style.marginRight = canvas.margin + 'px'
        this.contentContainer.style.marginTop = canvas.margin + 'px'
    }

    private removePopup() {
        this.container.style.display = 'none'
        if(this.container.parentElement != undefined) this.container.parentElement.removeChild(this.container)
    }

    private show() {
        this.container.style.display = 'block'
    }

    isRemoved(): boolean {
        return this.container.style.display == 'none'
    }
}
